import { Controller } from 'react-hook-form'
import UserFormField from '../../User/UserFormField'
import { useFormContextRequester } from '../utils/_utils'
import { ucfirst } from 'libs/ordoclic/src/lib/utilities'

const Profession = () => {
    const { control } = useFormContextRequester()

    return (
        <Controller
            control={control}
            name="profession"
            render={({ field, fieldState: { error } }) => (
                <UserFormField
                    variant="input"
                    label="Profession"
                    placeholder="Profession"
                    locked
                    disabled
                    status={{
                        error,
                        valid: (field.value?.label?.trim().length ?? 0) > 0,
                    }}
                    {...field}
                    value={ucfirst(field?.value?.label ?? '')}
                />
            )}
        />
    )
}

export default Profession
